// UpdateTeamStats.js
import React, { useState, useEffect } from "react";
import { useTournament } from "../TournamentContext";
import axios from "axios";
import config from "../../config/default.json";

const base_url = config.base_url;

const UpdateTeamStats = () => {
  const [teams, setTeams] = useState([]);
  const [standing, setStanding] = useState({});
  const [totalWins, setTotalWins] = useState({});
  const [totalLosses, setTotalLosses] = useState({});
  const [totalGamesPlayed, setTotalGamesPlayed] = useState({});
  const [selectedTeams, setSelectedTeams] = useState({});
  const { tournamentID } = useTournament();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (tournamentID) fetchTeams();
  }, [tournamentID]);

  const fetchTeams = async () => {
    try {
      const response = await axios.get(base_url + `/api/teams/${tournamentID}`);
      setTeams(response.data);
    } catch (error) {
      console.error("Failed to fetch teams", error);
    }
  };

  const handleChange = (setter, e, teamId) => {
    setter((prev) => ({
      ...prev,
      [teamId]: e.target.value,
    }));
  };

  const handleCheckboxChange = (teamId) => {
  setSelectedTeams((prev) => ({
    ...prev,
    [teamId]: !prev[teamId],
  }));
};


  const handleUpdateTeams = async () => {
    try {
      await Promise.all(
        teams.map(async (team) => {

             if (!selectedTeams[team._id]) return; 

          const updatedStanding = standing[team._id];
          const updatedWins = totalWins[team._id];
          const updatedLosses = totalLosses[team._id];
          const updatedGamesPlayed = totalGamesPlayed[team._id];

          if (
            updatedStanding !== undefined ||
            updatedWins !== undefined ||
            updatedLosses !== undefined ||
            updatedGamesPlayed !== undefined
          ) {
            await axios.put(`${base_url}/api/${tournamentID}/teamstat/${team._id}`, {
              standing: updatedStanding ?? team.standing,
              totalWins: updatedWins ?? team.totalWins,
              totalLosses: updatedLosses ?? team.totalLosses,
              totalGamesPlayed: updatedGamesPlayed ?? team.totalGamesPlayed,
            }, {headers: { Authorization: `Bearer ${token}` }});
          }
        })
      );

      alert("Teams updated successfully!");
      fetchTeams(); // refresh data
      setSelectedTeams({});
    } catch (error) {
      alert("Error: Teams not updated.");
      console.error("Failed to update teams", error);
    }
  };

  return (
    <div>
      <h2>Update Team Standings</h2>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
        }}
      >

        <thead>
  <tr style={{ background: "#f0f0f0" }}>
    <th style={{ border: "1px solid #ddd", padding: "8px" }}>Select</th>
    <th style={{ border: "1px solid #ddd", padding: "8px" }}>Division</th>
    <th style={{ border: "1px solid #ddd", padding: "8px" }}>Team Name</th>
    <th style={{ border: "1px solid #ddd", padding: "8px" }}>Standing</th>
    <th style={{ border: "1px solid #ddd", padding: "8px" }}>Total Games</th>
    <th style={{ border: "1px solid #ddd", padding: "8px" }}>Wins</th>
    <th style={{ border: "1px solid #ddd", padding: "8px" }}>Losses</th>
  </tr>
</thead>
<tbody>
  {teams.map((team, idx) => (
    <tr
      key={team._id}
      style={{
        background: idx % 2 === 0 ? "#fff" : "#f9f9f9",
      }}
    >
      <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
        <input
          type="checkbox"
          checked={selectedTeams[team._id] || false}
          onChange={() => handleCheckboxChange(team._id)}
        />
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        {team.division?.name || "N/A"}
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        {team.name}
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        <input
          type="number"
          value={standing[team._id] ?? team.standing ?? ""}
          disabled={!selectedTeams[team._id]}
          onChange={(e) => handleChange(setStanding, e, team._id)}
        />
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        <input
          type="number"
          value={totalGamesPlayed[team._id] ?? team.totalGamesPlayed ?? ""}
          disabled={!selectedTeams[team._id]}
          onChange={(e) => handleChange(setTotalGamesPlayed, e, team._id)}
        />
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        <input
          type="number"
          value={totalWins[team._id] ?? team.totalWins ?? ""}
          disabled={!selectedTeams[team._id]}
          onChange={(e) => handleChange(setTotalWins, e, team._id)}
        />
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        <input
          type="number"
          value={totalLosses[team._id] ?? team.totalLosses ?? ""}
          disabled={!selectedTeams[team._id]}
          onChange={(e) => handleChange(setTotalLosses, e, team._id)}
        />
      </td>
    </tr>
  ))}
</tbody>

      </table>

      <button
        onClick={handleUpdateTeams}
        style={{
          marginTop: "15px",
        
        }}
      >
        Update
      </button>
    </div>
  );
};

export default UpdateTeamStats;
